module.exports = __webpack_public_path__ + "static/media/cross.0416a9dc.svg";